import React from "react";
import { func } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Poppers from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import brandTheme from "brandTheme/Theme";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: brandTheme.headerBackGroundColor,
    position: "sticky",
    width: "100%",
  },
  popperNav: {
    zIndex:9,
    '@media only screen and (max-width: 960px) ': {
    position: "static !important",
    left: "unset !important",
    top: "unset !important",
    transform: "none !important",
    willChange: "none !important",
    width:"100%",
  }
},
dropdownItem:{
 backgroundColor:brandTheme.sideBarHoverColor,
 marginTop:"8px",
padding:"5px 24px",
fontWeight:"bold",
}
}));

const DropDown = ({ handleCloseProfile, navigateToLoginPage, openProfile, handleExitToSSO }) => {
    const { authToken } = useSelector((state) => state.login.authData);
    const dispatch = useDispatch();
    let navigate = useNavigate();
  const classes = useStyles();
  const handlelogout = async () => {
    const result = await apiHandler({
      url: endpoint.LOGOUT,
      authToken: authToken,
    });
    dispatch({ type: "SIGNOUT" });
    sessionStorage.removeItem('sessionId');
    navigate("/home/login");
  };
  return (
    <Poppers
    open={Boolean(openProfile)}
    anchorEl={openProfile}
    transition
    disablePortal
    className={classes.popperNav}
  >
    {({ TransitionProps, placement }) => (
      <Grow
        {...TransitionProps}
        id="profile-menu-list-grow"
        style={{
          transformOrigin:
            placement === "bottom" ? "center top" : "center bottom",
        }}
      >
        <Paper elevation={0}>
          <ClickAwayListener onClickAway={handleCloseProfile}>
            <MenuList role="menu" style={{paddingTop:"0",marginTop:"5px"}}>
              <MenuItem
                onClick={() => handlelogout()}
                className={classes.dropdownItem}
              >
                Logout
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Grow>
    )}
  </Poppers>
  );
};

DropDown.propTypes = {
  handleDrawerToggle: func,
};
export default DropDown;
